import { EppoInitializationError } from '#pplx/frontend/experimentation/openfeature/eppoInitializationError.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { OpenFeature } from '@openfeature/web-sdk';
export const EPPO_OPEN_FEATURE_DOMAIN = 'pplx-eppo';
// OpenFeature reports provider context-change rejections only through this logger, so this is
// the one place to classify them. Failed Eppo initialization is only actionable during an Eppo
// outage and is re-reported on every context change; keep it at debug, matching the loader.
function isKnownEppoInitFailure(args) {
    return args.some((arg) => arg instanceof EppoInitializationError);
}
const openFeatureLogger = {
    debug: () => undefined,
    error: (...args) => {
        if (isKnownEppoInitFailure(args))
            logger.debug(...args);
        else
            logger.error(...args);
    },
    info: (...args) => logger.info(...args),
    warn: (...args) => logger.warn(...args),
};
OpenFeature.setLogger(openFeatureLogger);
export const eppoOpenFeatureClient = OpenFeature.getClient(EPPO_OPEN_FEATURE_DOMAIN);
eppoOpenFeatureClient.setLogger(openFeatureLogger);
export async function setEppoOpenFeatureProviderAndWait(provider) {
    await OpenFeature.setProviderAndWait(EPPO_OPEN_FEATURE_DOMAIN, provider);
}
export function getCurrentEppoOpenFeatureContext() {
    return OpenFeature.getContext(EPPO_OPEN_FEATURE_DOMAIN);
}
//# sourceMappingURL=openFeatureClient.js.map